import { render, staticRenderFns } from "./certType.vue?vue&type=template&id=79802027&scoped=true"
import script from "./certType.vue?vue&type=script&lang=js"
export * from "./certType.vue?vue&type=script&lang=js"
import style0 from "./certType.vue?vue&type=style&index=0&id=79802027&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79802027",
  null
  
)

export default component.exports